import http from "./http.service";
import { getStorageItem } from "./storage.service";
export const ADD_NEW_LOCATION = `/partner/addNewLocation`;

export const getLocationById = async (locationId: string | null) => {
    let ID = locationId || getStorageItem("locationId");
    return http.get(`/partner/location/${ID}`);
}

export const getAllLocations = async () => {
    let partnerId =getStorageItem("id");
    return http.get(`/partner/all/locations/${partnerId}`)
}

export const editPartner = async (payload: any) => {
    const partnerId = getStorageItem("id");
    return http.put(`/partner/editProfile/${partnerId}`, payload);
}

export const getClassById = async (payload: any) => {
    const id = payload.id;
    return http.get(`/partner/class/${id}`)
}

export const addNewLocation = async (payload: any) => {
    return http.post(ADD_NEW_LOCATION, payload);
}
